import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useAppSelector } from '@/app/hooks';
import { selectUser } from '@/entities/user';
import { ProfitInfo } from '@/entities/profit';
import { LanguageSwitcher } from '@/features/language';
import { initials } from '@/shared/lib/initials';

// Строка аккаунта для layout.header = 'in-content' (макет telecom): язык, баланс
// с кошельками и аватар с инициалами в правом верхнем углу колонки контента.
// Полосы на всю ширину нет — это не Header, а первая строка main.
//
// Аватар ведёт в настройки: другого пути к профилю у бренда нет (в меню блока
// профиля нет, sidebarProfile = 'none').
//
// С какой ширины строка видна, решает MainLayout (класс md:flex / lg:flex): у
// бренда с рейкой она есть и на планшете, ниже — верхняя панель и меню с балансом.

export const AccountBar = ({ className }: { className?: string }) => {
  const user = useAppSelector(selectUser);
  const location = useLocation();
  const { t } = useTranslation('common');
  const isProfileActive = location.pathname === '/settings';

  return (
    <div className={cn('hidden items-center justify-end gap-3', className)}>
      <LanguageSwitcher nameFrom="lg" />
      <ProfitInfo variant="pill" />
      <Link
        to="/settings"
        title={user?.username ?? t('profile')}
        aria-label={t('profile')}
        className={cn(
          'flex size-10 shrink-0 items-center justify-center rounded-full bg-content-primary text-[13px] font-bold text-content-inverse transition-shadow',
          'hover:ring-2 hover:ring-action-primary hover:ring-offset-2 hover:ring-offset-surface-page',
          isProfileActive && 'ring-2 ring-action-primary ring-offset-2 ring-offset-surface-page',
        )}
      >
        {initials(user?.username)}
      </Link>
    </div>
  );
};

export default AccountBar;
